export const openModal = {
  methods: {
    openModal (i) {
      this.$store.dispatch('VIEW_SHOWMODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', i)
      document.body.classList.add('body-stop')
    }
  },
  data () {
    return {
      modalShow: false
    }
  }
}

export const closeModal = {
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
      document.body.classList.remove('body-stop')
    }
  }
}

export const toForm = {
  methods: {
    toForm (i, route) {
      this.$store.dispatch('VIEW_TYPES', i)
      this.$router.push(route)
    }
  }
}

export const toTech = {
  methods: {
    toTech (i, route) {
      this.$store.dispatch('VIEW_BODY', i)
      this.$router.push(route)
    }
  }
}

export const toWhyChooseUs = {
  methods: {
    toWhyChooseUs (i, route) {
      this.$store.dispatch('VIEW_BODY', i)
      this.$router.push(route)
    }
  }
}



// WEBPACK FOOTER //
// ./src/methods.js